import type { LightspeedOrder } from '@shared/types/reservations';
import { formatMoney } from '@shared/utils/currency';
import { useIsLightspeedEnabled } from 'restaurantAdmin/hooks/useIsLightspeedEnabled';
import styles from './ActiveReservationCard.scss';

interface OccupantSpendProps {
  order: LightspeedOrder | null | undefined;
}

/**
 * What the table has spent this visit: every check, open or paid, before tax, so it
 * matches the Order Details total. Nothing shows until Lightspeed has sent an order, rather than
 * $0.00, which would suggest the table ordered nothing.
 */
export const OccupantSpend = ({ order }: OccupantSpendProps) => {
  const isLightspeedEnabled = useIsLightspeedEnabled();

  if (!isLightspeedEnabled || !order || order.status === 'cancelled') {
    return null;
  }

  const amount = formatMoney(order.subtotal, order.currency);
  const state = order.status === 'open' ? 'Open' : 'Paid';

  return (
    <div className={styles.spend} data-testid="occupant-spend">
      {amount} · {state}
    </div>
  );
};
